import React from "react";
import { InfoProps } from "./types";
import CustomTypography from "../typography";
import "./styles.scss";

const classNameBase = "scd-info";

export default function Info({
  title,
  children,
}: InfoProps): React.JSX.Element {
  const classNameIcon = `icon icon-${classNameBase}`;

  const titleNode = title ? (
    <CustomTypography variant="subtitle1" className={`${classNameBase}-title`}>
      {title}
    </CustomTypography>
  ) : undefined;
  return (
    <div className={`${classNameBase}-container`}>
      <i className={classNameIcon} />
      <div className={`${classNameBase}-wrapper`}>
        {titleNode}
        <CustomTypography variant="body2" className={`${classNameBase}-text`}>
          {children}
        </CustomTypography>
      </div>
    </div>
  );
}
